import writeXlsxFile from "write-excel-file/browser";
import toast from "react-hot-toast";
import { format, parseISO, isValid } from "date-fns";
import type { UserResponse } from "@/types/settings";
import {
  EXPORT_USERS_FILE,
  EXPORT_USERS_FORMAT,
  EXPORT_USERS_HEADER_LABELS,
  EXPORT_USERS_LABEL,
  EXPORT_USERS_MESSAGE
} from "@/utils/exportUsersFields";

type Cell = { value: string };

function toDisplayDate(value: string | null | undefined): string {
  if (!value) return "";
  try {
    const parsed = parseISO(value);
    if (!isValid(parsed)) return "";
    return format(parsed, EXPORT_USERS_FORMAT.DATE);
  } catch {
    return "";
  }
}

function toSafeText(value: string | null | undefined): string {
  return value ?? "";
}

export async function exportUsersToExcel(users: UserResponse[]): Promise<void> {
  const exportDate = format(new Date(), EXPORT_USERS_FORMAT.DATE);

  const rows: (Cell[] | string[])[] = [
    [{ value: EXPORT_USERS_LABEL.EXPORT_DATE }, { value: exportDate }],
    [],
    EXPORT_USERS_HEADER_LABELS.map((label) => ({ value: label })),
    ...users.map((user) => [
      toSafeText(user.userName),
      toSafeText(user.email),
      toSafeText(user.roleName),
      toSafeText(user.businessNameCSV),
      toSafeText(user.meetingTypesNameCSV),
      toDisplayDate(user.createdDate),
      toDisplayDate(user.lastLoginDate)
    ])
  ];

  await writeXlsxFile(rows).toFile(EXPORT_USERS_FILE.NAME);
  toast.success(EXPORT_USERS_MESSAGE.SUCCESS);
}
